import { percentageSchemaValidator as validate } from 'schemas/ajv-validators';
import { validateWithAjv } from './validate-with-ajv';

export const validatePercentage = (value: unknown) => validateWithAjv(validate, value);
